import { Link } from 'react-router-dom';

function Cookies() {
  return (
    <section className="mb-3">
      <div className="container">
        <h1>Politique de Cookies</h1> Moovicar SAS, société au capital de 1.231.552,50 euros, sise
        au 35 rue Greneta, 75002 Paris, et enregistrée au R.C.S. de Paris sous le numéro 522 816 651
        (“Moovicar ”), met à disposition une Plateforme en ligne permettant la mise en relation
        entre, d’une part, les Loueurs et les Locataires.
        <p>
          Lors de votre utilisation de notre Plateforme, Moovicar et ses partenaires utilisent
          différents cookies, pixels, tags et autres outils de traçage (entendus ensemble comme les
          “Cookies”). La présente politique de cookies (la “Politique de Cookies ”) vous informe sur
          les types de Cookies utilisés, leur finalité ainsi que les moyens dont vous disposez pour
          restreindre ou non l’utilisation de ces Cookies lors de l’utilisation de notre
          Plateforme.{' '}
        </p>{' '}
        <p>
          La Politique de Cookies complète les conditions d’utilisation de la Plateforme et la
          Politique de Confidentialité.
        </p>{' '}
        Tous les termes en lettre majuscule doivent être entendus dans le même sens que ceux définis
        dans <Link to={'/terms'}> les conditions d’utilisation de la Plateforme</Link> et/ou{' '}
        <Link to={'/privacy'}>la Politique de Confidentialité.</Link>
        <h2 className="mt-2">Que sont les Cookies ?</h2>
        <div>
          Les Cookies sont des fichiers texte stockés sur votre ordinateur ou téléphone portable,
          qui gardent en mémoire des informations pour faire fonctionner les sites internet et/ou
          pour collecter des informations sur votre navigation.
        </div>
        <div className="cookie-policy">
          <h2>Politique de Cookies de Moovicar</h2>
          <p>
            Moovicar utilise des cookies pour offrir un service pratique avec de nombreuses
            fonctionnalités et pour optimiser sa plateforme et ses services. La transmission des
            données collectées se fait de manière sécurisée via une connexion cryptée.
          </p>

          <h3>Types de Cookies Utilisés par Moovicar</h3>

          <h4>1. Cookies Fonctionnels</h4>
          <p>
            Ces cookies sont indispensables au bon fonctionnement de la plateforme. Ils permettent
            la navigation ou l'utilisation des services et fonctionnalités du site et de
            l'application.
          </p>
          <ul>
            <li>Identifiant de session, authentification, sécurité, langue ou préférences.</li>
            <li>Garder en mémoire vos choix sur le dépôt de cookies.</li>
            <li>Mesurer l’audience de manière strictement nécessaire.</li>
            <li>Détecter les problèmes de navigation et optimiser les performances.</li>
          </ul>

          <h5>Cookies Fonctionnels Spécifiques :</h5>
          <ul>
            <li>
              <strong>_session_id</strong> : Permet la navigation pour un utilisateur connecté.
            </li>
            <li>
              <strong>remember_user_token</strong> : Permet à un utilisateur de rester connecté
              entre deux sessions de navigation.
            </li>
            <li>
              <strong>user_reference</strong> : Permet de retrouver la sélection de véhicules d’un
              utilisateur non connecté.
            </li>
            <li>
              <strong>ab_cookie</strong> : Assure la cohérence des contenus affichés lors d’un A/B
              test.
            </li>
            <li>
              <strong>dt_anonymous_id</strong> : Identifiant anonyme pour le suivi (aussi nommé
              "Moovicar Captur").
            </li>
          </ul>
          <p>
            <em>Note</em> : Ces cookies sont indispensables au service, ils sont activés
            automatiquement et ne peuvent pas être supprimés ou désactivés.
          </p>

          <h4>2. Cookies Non Fonctionnels</h4>
          <p>
            L’utilisation de ces cookies est soumise à votre consentement. Ils permettent le
            traitement de vos données personnelles par Moovicar et ses partenaires pour des
            finalités spécifiques.
          </p>

          <h5>Types de Cookies Non Fonctionnels :</h5>

          <h6>Cookies d’Analyse d’Audience</h6>
          <p>
            Opéré par le cookie "Moovicar Captur", ce cookie permet à Moovicar d’associer votre
            activité sur la plateforme à votre compte, afin de mieux comprendre vos interactions et
            d’améliorer les services proposés.
          </p>

          <h6>Cookies de Performance de la Navigation</h6>
          <p>
            Ces cookies recueillent des informations sur la manière dont vous utilisez notre site
            afin d’en améliorer l’efficacité. Ils sont utilisés pour :
          </p>
          <ul>
            <li>Établir des statistiques de fréquentation.</li>
            <li>Mesurer la performance, comme les pages visitées ou la durée de visite.</li>
            <li>Tester différentes fonctionnalités pour améliorer votre expérience.</li>
          </ul>

          <h6>Cookies de Personnalisation et d'Amélioration des Annonces</h6>
          <p>
            Ces cookies permettent d’optimiser les annonces relatives à Moovicar que vous recevez.
            Ils sont utilisés pour :
          </p>
          <ul>
            <li>Envoyer des annonces adaptées à votre profil.</li>
            <li>Suivre la performance des annonces pour en améliorer la qualité.</li>
          </ul>

          <h5>Liste des Partenaires</h5>
          <p>
            Les partenaires suivants de Moovicar déposent des cookies sur votre appareil et peuvent
            utiliser vos données. Voici le lien vers leur politique de confidentialité :
          </p>
          <ul>
            <li>
              <a
                href="https://www.hotjar.com/legal/policies/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hotjar (Cookies de performance de la navigation)
              </a>
            </li>
            <li>
              <a
                href="https://fr-fr.facebook.com/privacy/policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook Custom Audience (Personnalisation et amélioration des annonces)
              </a>
            </li>
            <li>
              <a
                href="https://business.safety.google/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Services (AdWords, Analytics, Remarketing, Double Click)
              </a>
            </li>
            <li>
              <a
                href="https://www.admo.tv/en/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cikneeto (Admo.tv)
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/legal/page/eea/privacy-policy/fr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tiktok Pixel
              </a>
            </li>
            <li>
              <a
                href="https://snap.com/fr-FR/privacy/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Snap Pixel
              </a>
            </li>
            <li>
              <a href="https://www.criteo.com/privacy/" target="_blank" rel="noopener noreferrer">
                Criteo
              </a>
            </li>
            <li>
              <a
                href="https://privacy.microsoft.com/fr-fr/privacystatement"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bing Ads (Microsoft)
              </a>
            </li>
            <li>
              <a
                href="https://www.adjust.com/terms/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Adjust
              </a>
            </li>
          </ul>

          <h5>Comment Gérer vos Préférences de Cookies ?</h5>
          <p>Vous pouvez gérer vos paramètres de cookies de plusieurs façons :</p>
          <ul>
            <li>
              <strong>Consentement :</strong> Une bannière s’affiche lors de votre visite pour
              accepter ou refuser certains cookies.
            </li>
            <li>
              <strong>Gestion par notre interface :</strong> Modifiez vos choix à tout moment via
              notre interface.
            </li>
            <li>
              <strong>Gestion par une plateforme interprofessionnelle :</strong> Désactivez certains
              cookies de personnalisation à l’adresse{' '}
              <a href="https://youronlinechoices.eu" target="_blank" rel="noopener noreferrer">
                https://youronlinechoices.eu
              </a>
              .
            </li>
            <li>
              <strong>Gestion par votre navigateur Internet :</strong> Configurez votre navigateur
              pour gérer les cookies (Edge, Chrome, Safari, Firefox).
            </li>
            <li>
              <strong>Gestion par le système d’exploitation de votre smartphone :</strong>{' '}
              Paramétrez les règles de cookies dans votre système d’exploitation mobile.
            </li>
          </ul>

          <p>
            Note : Restreindre certains cookies peut affecter la fonctionnalité du site et la
            qualité des services.
          </p>

          <h5>Durée de Conservation</h5>
          <ul>
            <li>Vos choix d'acceptation ou de refus des cookies sont conservés pour 12 mois.</li>
            <li>Les cookies eux-mêmes sont conservés pendant au maximum 13 mois.</li>
          </ul>
        </div>
        <div className="text-center">
          <Link className="btn btn-outline-lg mb-2" to="/help">
            Voir le centre d'aide <i className="bi bi-arrow-right-circle h5"></i>
          </Link>
        </div>
        <hr
          style={{
            border: '1px solid #ff6600',
            width: '100%',
            margin: '20px 0', // Pas de margin auto pour éviter la centration
          }}
        />{' '}
      </div>
    </section>
  );
}

export default Cookies;
